import { gql } from "@apollo/client";

export const CHECK_USER_AUTHENTICATED = gql`
  {
    isAuthenticated {
      status
    }
    getUserByToken {
      accountingFirms
      companies
      isActive
      userCategory {
        id
        name
        slug
      }
      isSuperuser
      id
      firstName
      lastName
      email
      username
      permissions
      language
    }
  }
`;
